
































import { RootState } from '@/store/store';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import CourseLicenseTemplateForm from './components/CourseLicenseTemplateForm.vue';
import { CourseLicenseTemplateResponse } from '@/jbi-shared/dto/jtms.dtos';
import { ApiAxiosError, ApiState } from '@/store/types/general.types';
import { ToastProgrammatic } from 'buefy';

@Component({
  components: {
    CourseLicenseTemplateForm
  }
})
export default class DeleteCourseLicenseTemplateModal extends Vue {
  @Prop({ type: Object }) courseLicenseTemplate!: CourseLicenseTemplateResponse;

  @Action('courseLicenseTemplate/deleteCourseLicenseTemplate')
  deleteCourseLicenseTemplate!: (id: number) => void;

  @State(
    (state: RootState) =>
      state.courseLicenseTemplate.apiState.deleteCourseLicenseTemplate
  )
  deleteCourseLicenseTemplateApiState!: ApiState;

  processRemoveCourseLicenseTemplate() {
    this.deleteCourseLicenseTemplate(this.courseLicenseTemplate.id);
  }

  closeModal() {
    this.$emit('close');
  }

  triggerPageRefresh() {
    this.$emit('refreshPage');
  }

  @Watch('deleteCourseLicenseTemplateApiState', { deep: true })
  onDeleteCourseLicenseTemplateApiStateChanged(state: ApiState) {
    if (state.success) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-dark',
        position: 'is-top',
        message: `Course License Template successfully removed.`
      });

      this.closeModal();
      this.triggerPageRefresh();
    }

    if (state.error) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(
          (state.error as ApiAxiosError)?.response?.data?.message || state.error
        ),
        duration: 5000
      });
    }
  }
}
